<template>
  <div class="c-group">
    <filters
      v-if="mediaVal === 6"
      :states="states"
      placeholder="请输入创意名称或ID"
      agent
      promoted
      @on-change="filterData"
      @on-search="searchFilterData"
    ></filters>

    <filters
      v-else
      :states="states"
      placeholder="请输入创意名称或ID"
      agent
      game
      @on-change="filterData"
      @on-search="searchFilterData"
    ></filters>

    <Row class="c-control-btn">
      <Col span="8">
        <Button type="primary" @click="openNewEntry">新建{{ open }}</Button>
        <!-- <Button type="primary" @click="modalOpen = true" v-if="mediaVal !== 45">新建创意</Button> -->
        <Dropdown class="c-btn-group" @on-click="betch">
          <a href="javascript:void(0)">
            批量操作
            <Icon type="ios-arrow-down"></Icon>
          </a>
          <DropdownMenu slot="list">
            <DropdownItem :name="1">启用</DropdownItem>
            <DropdownItem :name="2">暂停</DropdownItem>
            <DropdownItem :name="-1">删除</DropdownItem>
          </DropdownMenu>
        </Dropdown>
        <Button v-if="mediaVal === 16" @click="downData" class="c-btn-margin">数据导出</Button>
        <Tag
          v-if="id > 0 && mediaVal === 6"
          style="margin-left: 12px; padding: 5px 15px 6px; height: 32px"
          color="primary"
          closable
          @on-close="clearExtraFilter"
        >
          1个推广计划中的创意
        </Tag>
      </Col>
      <Col span="8" offset="8">
        <Button class="g-pull-right" @click="modalColumn = true">自定义列</Button>
        <div class="g-pull-right">
          <div class="c-account-balance">
            <span>账户余额：</span>
            <Icon v-if="balancing" type="ios-loading" size="18" class="c-account-load" color="#2b85e4"></Icon>
            <span v-else>{{ balance | toThousands }} 元</span>
          </div>
        </div>
      </Col>
    </Row>
    <!-- 表格列表 -->
    <div class="c-table-list">
      <Viewport v-model="tableHeight">
        <idea-table
          ref="ideaTable"
          :value="spining"
          :data="ideaList"
          :columns="tableCol"
          :media="mediaVal"
          :height="tableHeight"
          @on-sort="sortTable"
          @on-refresh="getData"
          @header-dragend="headerDragend"
        ></idea-table>
        <Page
          show-total
          show-sizer
          show-elevator
          :total="total"
          :current.sync="pageIndex"
          :page-size="pageSize"
          :page-size-opts="[10, 20, 30, 40, 100]"
          @on-change="changePageIndex"
          @on-page-size-change="changePageSize"
          class="c-table-page pager"
          size="small"
        />
      </Viewport>
    </div>
    <!-- 新建对话框 -->
    <open-modal v-model="modalOpen" title="新建创意" :media="mediaVal" @on-cancel="modalOpen = false" group plan></open-modal>
    <!-- 自定义列 -->
    <custom-column v-model="modalColumn" :data="columns" @on-select="selectColumn" />
  </div>
</template>
<script>
import mixin from './mixin'
import { mapActions } from 'vuex'
import { getIdeaList } from '@/api/convert.model'
import { HOST_API } from '@/api/config'
import Filters from '@/components/converter/filter.vue'
import OpenModal from '@/components/converter/open-modal.vue'
import CustomColumn from '@/components/converter/custom-column.vue'
import IdeaTable from '@/components/converter/table/table-idea.vue'

import { IDEA_TOUTIAO, IDEA_UC, IDEA_TENCENT, IDEA_BAIDU, IDEA_KUAISHOU } from '../data/tableTitle'
import { isEmpty } from '@/common/js/utils'

export default {
  name: 'IdeaList',
  mixins: [mixin],
  components: { Filters, CustomColumn, OpenModal, IdeaTable },
  computed: {
    mediaVal() {
      return parseInt(this.$route.params.id)
    },
    // 存local用户自定义列
    custom() {
      let custom
      if (this.mediaVal === 10) custom = 'idea'
      else if (this.mediaVal === 6) custom = 'ucidea'
      else if (this.mediaVal === 16) custom = 'teidea'
      else if (this.mediaVal === 45) custom = 'bdidea'
      else if (this.mediaVal === 32) custom = 'ksidea'
      return custom
    },
    tableCol() {
      return this.columns.filter((ret) => !ret.show)
    },
    open() {
      let title
      if (this.mediaVal === 10) title = '投放计划'
      else if (this.mediaVal === 6) title = '推广计划'
      else if (this.mediaVal === 16) title = '计划'
      else if (this.mediaVal === 45) title = '推广单元'
      else if (this.mediaVal === 32) title = '计划组'
      return title
    }
  },
  watch: {
    columns: {
      handler(nVal) {
        const show = nVal.filter((ret) => !ret.show).map((met) => `${met.key}${met.width ? `|${met.width}` : ''}`)
        this.setCustomStorage(`${this.custom}CustomColumn`, show)
        this.$nextTick(() => {
          this.$refs.ideaTable && this.$refs.ideaTable.doLayout()
        })
      },
      deep: true
    },
    adId: {
      handler(nVal, oVal) {
        if (nVal !== oVal) {
          this.getData()
        }
      },
      deep: true
    },
    $route(to, from) {
      if (this.$router.currentRoute.query.adAccountId) {
        this.id = this.$router.currentRoute.query.id
        this.adId = this.$router.currentRoute.query.adId
        this.adAccountId = this.$router.currentRoute.query.adAccountId
      }
    }
  },
  methods: {
    ...mapActions('Convert', ['handleAsync']),
    // 自定义列 全选
    selectColumnAll(params) {
      const { type, show } = params
      const data = this.columns.filter((ret) => ret.type === type)
      data.forEach((ret) => {
        this.$set(ret, 'show', show)
      })
    },
    clearExtraFilter() {
      this.adAccountId = ''
      this.adId = ''
      this.id = ''
    },
    getData(filter) {
      let params = {
        mediaId: this.mediaVal,
        page_id: this.pageIndex,
        page_size: this.pageSize,
        sort: this.sort,
        order: this.order
      }

      if (filter) params = Object.assign(params, filter)
      else params = Object.assign(this.params, params)

      // 保存参数
      this.params = JSON.parse(JSON.stringify(params))

      // 投放计划id（临时参数）
      if (this.id) params = Object.assign(params, { adGroupId: this.id })
      if (this.adId) params = Object.assign(params, { adId: this.adId })
      if (!params.adAccountId) params = Object.assign(params, { adAccountId: this.adAccountId })

      // 请求数据
      this.spining = true
      getIdeaList(
        Object.assign(params, {
          selectJson: JSON.stringify(params)
        })
      ).then((data) => {
        this.spining = false
        if (data && data.list && data.page_info) {
          // eslint-disable-next-line
          const { total_number } = data.page_info
          const fmt_tofix = (num) => parseFloat(num.toFixed(2))
          this.ideaList = data.list.map((ret) => {
            ret.optStatus = ret.optStatus === 1
            ret.paperAmount = fmt_tofix(ret.paperAmount)
            ret.amount = fmt_tofix(ret.amount)
            ret.perClickPrice = fmt_tofix(ret.perClickPrice)
            ret.thousandsOfDisplayCosts = fmt_tofix(ret.thousandsOfDisplayCosts)
            ret.convertCost = fmt_tofix(ret.convertCost)
            ret.activeCost = fmt_tofix(ret.activeCost)
            ret.registerCost = fmt_tofix(ret.registerCost)
            if (this.mediaVal === 6) ret.imageMode = 'CREATIVE_IMAGE_MODE_VIDEO'
            return ret
          })
          // eslint-disable-next-line
          this.total = total_number ? total_number : 0
          this.$nextTick(() => {
            this.$refs.ideaTable && this.$refs.ideaTable.doLayout()
          })
          this.handleAsync()
        }
      })
    },
    changePageIndex(index) {
      this.pageIndex = index
      this.getData()
    },
    changePageSize(size) {
      this.setLocalPage(size)
      this.pageSize = size
      if (this.pageIndex === 1) this.getData()
    },
    betch(type) {
      if ([1, 2, -1].includes(type)) {
        this.$refs.ideaTable.changeBetch(type)
      }
    },
    downData() {
      let url = `${HOST_API}/api/ptom/adCreative/down`
      url += `?sessionid=${this.$store.state.token}&mediaId=${this.mediaVal}`
      url += `&queryBeginTime=${this.params.queryBeginTime}&queryEndTime=${this.params.queryEndTime}`
      this.params.adAccountId && (url += `&adAccountId=${this.params.adAccountId}`)
      this.params.opId && (url += `&opId=${this.params.opId}`)
      this.params.gameId && (url += `&gameId=${this.params.gameId}`)
      !isEmpty(this.params.status) && (url += `&status=${this.params.status}`)
      this.params.keyWord && (url += `&keyWord=${this.params.keyWord}`)
      this.params.order && (url += `&order=${this.params.order}`)
      this.params.sort && (url += `&sort=${this.params.sort}`)
      window.open(url)
    }
  },
  data() {
    return {
      tableHeight: 330,
      id: this.$router.currentRoute.query.id,
      adId: this.$router.currentRoute.query.adId,
      adAccountId: this.$router.currentRoute.query.adAccountId,
      modalOpen: false, // 新建对话框
      modalColumn: false, // 自定义列
      spining: null, // 表格数据加载
      ideaList: [], // 广告创意列表
      columns: [],
      states: [
        {
          value: -1,
          label: '不限'
        },
        {
          value: 0,
          label: '未知'
        },
        {
          value: 1,
          label: '启动'
        },
        {
          value: 2,
          label: '暂停'
        },
        {
          value: 3,
          label: '审核中'
        },
        {
          value: 4,
          label: '审核不通过'
        },
        {
          value: 5,
          label: '账户余额不足'
        },
        {
          value: 6,
          label: '计划预算不足'
        },
        {
          value: 7,
          label: '不在投放时段'
        },
        {
          value: 8,
          label: '计划组暂停'
        },
        {
          value: 9,
          label: '计划暂停'
        },
        {
          value: 10,
          label: '预上线'
        },
        {
          value: 11,
          label: '计划新建审核中'
        },
        {
          value: 12,
          label: '计划修改审核中'
        },
        {
          value: 13,
          label: '计划审核不通过'
        }
      ]
    }
  },
  created() {
    let columns
    const shows = this.getCustomStorage(`${this.custom}CustomColumn`)
    // 表格列数据
    if (this.mediaVal === 10) columns = IDEA_TOUTIAO
    else if (this.mediaVal === 6) columns = IDEA_UC
    else if (this.mediaVal === 16) columns = IDEA_TENCENT
    else if (this.mediaVal === 45) columns = IDEA_BAIDU
    else if (this.mediaVal === 32) columns = IDEA_KUAISHOU
    // 同步本地存储自定义列
    if (shows.length) {
      this.columns = columns
        .sort((a, b) => {
          const idxA = shows.findIndex((ret) => ret.includes(a.key))
          const idxB = shows.findIndex((ret) => ret.includes(b.key))
          const sortA = idxA < 0 ? idxA : shows.length - idxA
          const sortB = idxB < 0 ? idxB : shows.length - idxB
          return sortB - sortA
        })
        .map((ret) => {
          const shifRet = shows.filter((met) => met && met.includes('|') && met.includes(ret.key)).shift()
          ret.show = !shows
            .filter((met) => met)
            .map((met) => (met.includes('|') ? met.split('|').shift() : met))
            .includes(ret.key)
          shifRet && (ret.width = parseInt(Number(shifRet.split('|').pop() || '')))
          return ret
        })
    } else {
      this.columns = [...columns]
    }
  }
}
</script>
<style lang="scss" scoped>
.c-group {
  .c-control-btn {
    background-color: #fff;
    width: 100%;
    margin-bottom: 5px;

    .ivu-btn {
      margin-left: 0 !important;
    }

    .c-btn-group {
      padding-left: 15px;
      margin-left: 12px;
      line-height: 30px;
      height: 32px;
      border-radius: 3px;
      border: solid 1px #2d8cf0;
      width: 100px;
      display: inline-block;
      vertical-align: middle;
    }

    .c-btn-margin {
      margin-left: 12px !important;
    }
  }

  .c-table-page {
    padding: 5px 0;
    text-align: right;
  }

  .c-account-balance {
    line-height: 32px;
    font-size: 14px;
    padding: 0 12px;
    margin-right: 8px;
    color: #ff0000;
  }

  .c-account-load {
    animation: ani-demo-spin 1s linear infinite;
  }
}
</style>
